import "./CustomSelect.css";
import { openBlock as s, createElementBlock as u, createElementVNode as c, defineComponent as y, useCssVars as V, unref as m, ref as f, computed as d, normalizeClass as E, createTextVNode as B, toDisplayString as _, createVNode as x, Transition as N, withCtx as S, Fragment as $, renderList as I, createCommentVNode as z } from "vue";
import { a as A, o as b } from "./index-487dfa1c.js";
import { _ as D } from "./_plugin-vue_export-helper-dad06003.js";
function L(p, v) {
  return s(), u("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    c("path", { d: "M0 6a.5.5 0 01.853-.354l8.646 8.646 8.646-8.646a.5.5 0 01.707.707l-9 9a.5.5 0 01-.707 0l-9-9a.498.498 0 01-.146-.354z" })
  ]);
}
const T = ["tabindex", "aria-expanded", "aria-label"], F = {
  key: 0,
  id: "custom-select-items",
  class: "items",
  role: "listbox"
}, K = ["aria-selected"], M = ["onClick"], P = /* @__PURE__ */ y({
  __name: "CustomSelect",
  props: {
    options: {},
    modelValue: {},
    tabindex: { default: 0 }
  },
  emits: ["update:modelValue"],
  setup(p, { emit: v }) {
    V((e) => ({
      fa6ca844: `${m(g)}px`
    }));
    const o = p, C = v, r = f(), {
      width: g
    } = A(r), t = f(!1), l = d({
      get() {
        return o.modelValue;
      },
      set(e) {
        C("update:modelValue", e);
      }
    }), w = d(() => {
      var e;
      return (e = o.options.find((a) => a.value === l.value)) == null ? void 0 : e.label;
    }), i = d(() => o.options.findIndex((e) => e.value === l.value));
    function h() {
      i.value < o.options.length - 1 && (l.value = o.options[i.value + 1].value);
    }
    function k() {
      i.value > 0 && (l.value = o.options[i.value - 1].value);
    }
    return b("ArrowDown", () => {
      t.value ? h() : t.value = !0;
    }, { target: r }), b("ArrowUp", () => {
      k();
    }, { target: r }), (e, a) => (s(), u("div", {
      class: "custom-select",
      onBlur: a[1] || (a[1] = (n) => t.value = !1)
    }, [
      c("button", {
        ref_key: "selectedElement",
        ref: r,
        type: "button",
        role: "combobox",
        tabindex: e.tabindex,
        "aria-expanded": t.value,
        "aria-haspopup": "",
        "aria-controls": "custom-select-items",
        "aria-label": o.options[0].label,
        class: E(["selected", { open: t.value }]),
        onClick: a[0] || (a[0] = (n) => t.value = !t.value)
      }, [
        B(_(w.value) + " ", 1),
        c("i", null, [
          x(m(L))
        ])
      ], 10, T),
      x(N, { name: "fade" }, {
        default: S(() => [
          t.value ? (s(), u("div", F, [
            (s(!0), u($, null, I(e.options, (n) => (s(), u("div", {
              key: n.value,
              role: "option",
              "aria-selected": l.value === n.value
            }, [
              c("button", {
                type: "button",
                tabindex: "-1",
                onClick: (U) => {
                  l.value = n.value, t.value = !1;
                }
              }, _(n.label), 9, M)
            ], 8, K))), 128))
          ])) : z("", !0)
        ]),
        _: 1
      })
    ], 32));
  }
});
const H = /* @__PURE__ */ D(P, [["__scopeId", "data-v-cac44ecf"]]);
export {
  H as default
};
//# sourceMappingURL=CustomSelect.js.map
